import * as React from 'react';
import { Container, TwoColumnLayout, TextPassage, Section, Well, ProgressBar, DefinitionList, TextLink, Button } from 'react-unity';
import moment from 'moment';
import WorkflowInstance from '../../../models/WorkflowInstance';
import WorkflowStateBadge from '../WorkflowStateBadge';
import { LinkTree, LinkTreeItem } from '../LinkTree';
import './WorkflowDetailWrapper.css';
import WorkflowHistoryModal from '../../OnPremPortOpeningRequests/components/WorkflowHistoryModal';
import serviceNow from '../../../services/serviceNow.config';

interface WorkflowDetailWrapperProps {
	title: string;
	loading?: boolean;
	workflowInstance?: WorkflowInstance;
	linkTree?: LinkTreeItem[];
	actions?: any;
	fromPOR?: boolean;
	fromDNDR?: boolean;
	children?: any;
}

interface WorkflowDetailWrapperState {
	isHistoryModalVisible: boolean;
}

export default class WorkflowDetailWrapper extends React.Component<WorkflowDetailWrapperProps,WorkflowDetailWrapperState> {
	constructor(props: WorkflowDetailWrapperProps) {
		super(props);
		this.state = {
			isHistoryModalVisible: false,
		};
		this.toggleHistoryModal = this.toggleHistoryModal.bind(this);
	}

	hasAvailableActions = () : boolean => {
		return !!this.props.actions && this.props.actions?.props?.children?.some(action => !!action);
	};

	toggleHistoryModal() {
		this.setState((prevState) => ({
			isHistoryModalVisible: !prevState.isHistoryModalVisible,
		}));
	}

	getTicketURL = (ticket: string) => {
		return ticket.toUpperCase().includes('CRQ') ?
			`https://itconsole.na.xom.com/#/${ticket}`
			: `https://${serviceNow.serviceNowEnv}.service-now.com/nav_to.do?uri=change_request.do?sysparm_query=number=${ticket}&sysparm_limit=1`;
	};

	render() {
		const currentState = this.props.workflowInstance?.currentWorkflowInstanceState;
		const workflowInstanceStates = this.props.workflowInstance?.workflowInstanceStates || [];
		return (
			<Container className="em-u-max-width-layout em-u-margin-top-double em-u-margin-bottom-double">
				{!this.props.loading && this.props.linkTree?.length > 0 &&
					<LinkTree links={this.props.linkTree} />}
				<TextPassage>
					<h2 className="em-u-margin-top-double">
						{
							!this.props.loading ? this.props.title
								:
								<ProgressBar indeterminate hideValueLabel label="Loading data..." />
						}
					</h2>
				</TextPassage>
				{!this.props.loading &&
					<TwoColumnLayout>
						<TwoColumnLayout.Main className="em-u-margin-right-quad">
							{this.props.children}
						</TwoColumnLayout.Main>
						<TwoColumnLayout.Secondary>
							<Well id="well" className="em-u-min-width-20 border-color">
								{this.hasAvailableActions() &&
								<Section id="actions-section" title="Actions" className="container-style">
									{this.props.actions}
								</Section>}
								<Section title="Request" className="container-style">
									<DefinitionList>
										{!this.props.fromPOR || !this.props.fromDNDR &&
											<DefinitionList.Item>
												<DefinitionList.Item.Key>Current Status</DefinitionList.Item.Key>
												<DefinitionList.Item.Value>
													<WorkflowStateBadge
														workflowState={currentState.workflowState}
													/>
												</DefinitionList.Item.Value>
											</DefinitionList.Item>
										}
										<DefinitionList.Item>
											<DefinitionList.Item.Key>Requested By</DefinitionList.Item.Key>
											<DefinitionList.Item.Value style={{wordBreak: 'break-all'}}>
												{this.props.workflowInstance?.createdBy.displayName}
											</DefinitionList.Item.Value>
										</DefinitionList.Item>
										<DefinitionList.Item>
											<DefinitionList.Item.Key>Requested Date</DefinitionList.Item.Key>
											<DefinitionList.Item.Value>
												{moment(this.props.workflowInstance?.createdDate).format('MMM DD, YYYY')}
											</DefinitionList.Item.Value>
										</DefinitionList.Item>
										{this.props.workflowInstance?.currentWorkflowInstanceState.ticketId !== null &&
											<DefinitionList.Item>
												<DefinitionList.Item.Key>Ticket #</DefinitionList.Item.Key>
												<DefinitionList.Item.Value>
													<TextLink
														external
														href={this.getTicketURL(this.props.workflowInstance?.currentWorkflowInstanceState.ticketId)}
														target="_blank"
														className="em-u-display-inline"
													>
														<span>{this.props.workflowInstance?.currentWorkflowInstanceState.ticketId}</span>&nbsp;
													</TextLink>
												</DefinitionList.Item.Value>
											</DefinitionList.Item>}
									</DefinitionList>
									<Button
										variant="secondary"
										className="em-u-margin-top"
										onClick={this.toggleHistoryModal}
									>
										View Workflow History
									</Button>
								</Section >
								{!!currentState.performedReason && 
								<Section title="Last Comment" className="container-style">
									<p>
										{currentState.performedReason}
									</p>
									<small>
										<i>
											{currentState.performedByUser.displayName}, {moment(currentState.performedOnDate).format('MM/DD/YYYY')}
										</i>
									</small>
								</Section>}
							</Well>
						</TwoColumnLayout.Secondary>
					</TwoColumnLayout>}
					<WorkflowHistoryModal
						visible={this.state.isHistoryModalVisible}
						onClose={this.toggleHistoryModal}
						workflowInstanceStates={workflowInstanceStates}
					/>
			</Container>
		);
	}
}